module.exports = __webpack_public_path__ + "img/icone-ferramentas.7cea597c.svg";